import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-time-register-split',
  templateUrl: './time-register-split.component.html',
  styleUrls: ['./time-register-split.component.css']
})
export class TimeRegisterSplitComponent implements OnInit {
    powTimeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.powTimeKeyno = this.stateService.getStateParams()['powtime_keyno'];
    }

    private async loadEdit() {
        if (!!this.powTimeKeyno) {
            this.edit = (await this.datatask.Post(1860, { powtime_keyno: this.powTimeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1861, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    powtime_keyno: string;
    timestamp_start: string;
    timestamp_end: string;
    timestamp_split: string;
}
